import script from "./LapCounterBar.vue?vue&type=script&setup=true&lang=js"
export * from "./LapCounterBar.vue?vue&type=script&setup=true&lang=js"

import "./LapCounterBar.vue?vue&type=style&index=0&id=2fc49c3f&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/set-repository-web-glasses/glasses-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fc49c3f"]])

export default __exports__